import { render } from "./DefCollection.vue?vue&type=template&id=d95f3254&scoped=true"
import script from "./DefCollection.vue?vue&type=script&lang=js"
export * from "./DefCollection.vue?vue&type=script&lang=js"

import "./DefCollection.vue?vue&type=style&index=0&id=d95f3254&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d95f3254"]])

export default __exports__